import { useMemo } from 'react';
import { toNumber } from 'lodash';

import { EligibleExpense } from '../../FileScan/fileScan.types';
import {useClaimInfoFieldsFilterStore } from '../stores/useClaimInfoFieldsFilter.store';

import { sortExpensesByObject } from './sortExpensesByObject';

interface Props {
  eligibleExpenses?: EligibleExpense[],
}

const useFilteredExpensesOptions = ({ eligibleExpenses }: Props) => {
  const { filterByValues } = useClaimInfoFieldsFilterStore();

  const sortedExpenses = useMemo(() => sortExpensesByObject(eligibleExpenses, filterByValues), [filterByValues, eligibleExpenses]);

  const sortedExpensesOptions = useMemo(() => sortedExpenses
    ?.map((expense) => expense?.expense), 
  [sortedExpenses]);

  const filteredExpense = useMemo(() => sortedExpenses
    .filter((sortedExpense) => sortedExpense.isFullMatching)
    .map((filteredExpense) => filteredExpense.expense)
    .sort((prev, next) => toNumber(prev.amount) < toNumber(next.amount) ? 1 : -1)?.[0], 
  [sortedExpenses]);

  return {
    sortedExpensesOptions,
    filteredExpense,
  };
};

export default useFilteredExpensesOptions;
